/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, ButtonGroup, Card, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { ProgressChartLoader } from '../progress/ChartLoader';
import { ProductivityChartLoader } from '../productivity/ChartLoader';
import { CostsChartLoader } from '../costs/ChartLoader';


export const Activityresume: React.FC = () => {
  const [currentView, setCurrentView] = useState<'productivity' | 'progress' | 'costs'>('progress');

  return (
    <Box sx={{ width: '100%', margin: '0'}}>

      <Card>
        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <ButtonGroup size="small" variant="outlined">
              <Button 
                onClick={() => setCurrentView('progress')}
                variant={currentView === 'progress' ? 'contained' : 'outlined'}
              >
                Progreso
              </Button>
              <Button 
                onClick={() => setCurrentView('costs')}
                variant={currentView === 'costs' ? 'contained' : 'outlined'}
              >
                Costos
              </Button>
              <Button 
                onClick={() => setCurrentView('productivity')}
                variant={currentView === 'productivity' ? 'contained' : 'outlined'}
              >
                Productividad
              </Button>
            </ButtonGroup>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent sx={{ p: 0, '&:last-child': { pb: 1 } }}>
            <ProductivityChartLoader hidden={currentView !== 'productivity'} />
            <ProgressChartLoader hidden={currentView !== 'progress'} />
            <CostsChartLoader hidden={currentView !== 'costs'}/>
        </CardContent>
      </Card>
    </Box>

  );
};